import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface CoachFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const CoachForm: React.FC<CoachFormProps> = ({
  updateDetails,
  data
}) => {
  const [teamInput, setTeamInput] = useState('');
  const handleAddTeam = () => {
    if (teamInput.trim() !== '') {
      const currentTeams = data.profileDetails?.teamsCoached || [];
      updateDetails({
        teamsCoached: [...currentTeams, teamInput.trim()]
      });
      setTeamInput('');
    }
  };
  const handleRemoveTeam = (index: number) => {
    const currentTeams = [...(data.profileDetails?.teamsCoached || [])];
    currentTeams.splice(index, 1);
    updateDetails({
      teamsCoached: currentTeams
    });
  };
  return <div className="space-y-4" data-id="element-55">
      <div data-id="element-56">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-57">
          Coaching Specialty
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Offensive Strategy, Youth Development" value={data.profileDetails?.coachingSpecialty || ''} onChange={e => updateDetails({
        coachingSpecialty: e.target.value
      })} data-id="element-58" />
      </div>
      <div data-id="element-59">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-60">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 10" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-61" />
      </div>
      <div data-id="element-62">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-63">
          Coaching Level
        </label>
        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" value={data.profileDetails?.coachingLevel || ''} onChange={e => updateDetails({
        coachingLevel: e.target.value
      })} data-id="element-64">
          <option value="" data-id="element-65">Select level</option>
          <option value="Youth" data-id="element-66">Youth</option>
          <option value="Amateur" data-id="element-67">Amateur</option>
          <option value="Semi-Professional" data-id="element-68">Semi-Professional</option>
          <option value="Professional" data-id="element-69">Professional</option>
          <option value="International" data-id="element-70">International</option>
        </select>
      </div>
      <div data-id="element-71">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-72">
          Teams Coached
        </label>
        <div className="flex" data-id="element-73">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. FC Barcelona Youth" value={teamInput} onChange={e => setTeamInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddTeam())} data-id="element-74" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddTeam} data-id="element-75">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-76">
          {(data.profileDetails?.teamsCoached || []).map((team, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-77">
              <span className="flex-1" data-id="element-78">{team}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveTeam(index)} data-id="element-79">
                <XIcon size={16} data-id="element-80" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default CoachForm;